import { render, staticRenderFns } from "./DotTextDisplay.vue?vue&type=template&id=2f54dc38&scoped=true&"
import script from "./DotTextDisplay.vue?vue&type=script&lang=js&"
export * from "./DotTextDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DotTextDisplay.vue?vue&type=style&index=0&id=2f54dc38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54dc38",
  null
  
)

export default component.exports